(() => {
  'use strict';

  class PWProductCardSlider {

    constructor(element) {

      this.element = element;

      this.slides = Array.from(
        element.querySelectorAll('[data-pw-slide]')
      );

      this.dots = Array.from(
        element.querySelectorAll('[data-pw-dot]')
      );

      this.currentIndex = 0;

      this.delay = parseInt(
        element.dataset.delay || '4800',
        10
      );

      this.startDelay = parseInt(
        element.dataset.startDelay || '0',
        10
      );

      this.autoplay =
        element.dataset.autoplay !== 'false';

      this.timeout = null;
      this.interval = null;

      this.visible = false;
      this.hovering = false;
      this.hasStarted = false;

      this.reduceMotion =
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

      /*
       * Guarda referência no próprio DOM.
       * Isso será usado pelos controles.
       */
      element.pwSliderInstance = this;

      if (this.slides.length <= 1) {
        return;
      }

      this.observe();
      this.bindHover();
      this.preloadNext();

    }


    /* =====================================================
       IMAGE LOAD
       ===================================================== */

    loadImage(index) {

      const slide = this.slides[index];

      if (!slide) {
        return;
      }

      const image =
        slide.querySelector('[data-pw-src]');

      if (!image) {
        return;
      }

      const src = image.dataset.pwSrc;

      if (!src) {
        return;
      }

      const preload = new Image();

      preload.onload = () => {

        image.src = src;

        image.removeAttribute(
          'data-pw-src'
        );

      };

      preload.src = src;

    }


    preloadNext() {

      const nextIndex =
        (this.currentIndex + 1) %
        this.slides.length;

      this.loadImage(nextIndex);

    }


    /* =====================================================
       SHOW SLIDE
       ===================================================== */

    show(index) {

      if (index < 0) {

        index =
          this.slides.length - 1;

      }

      if (index >= this.slides.length) {

        index = 0;

      }

      this.loadImage(index);


      this.slides.forEach(
        (slide, slideIndex) => {

          const active =
            slideIndex === index;

          slide.classList.toggle(
            'is-active',
            active
          );

        }
      );


      this.dots.forEach(
        (dot, dotIndex) => {

          const active =
            dotIndex === index;

          dot.classList.toggle(
            'is-active',
            active
          );

          dot.setAttribute(
            'aria-current',
            active ? 'true' : 'false'
          );

        }
      );


      this.currentIndex = index;

      this.preloadNext();

    }


    next() {

      this.show(
        this.currentIndex + 1
      );

    }


    previous() {

      this.show(
        this.currentIndex - 1
      );

    }


    /* =====================================================
       TIMER
       ===================================================== */

    clearTimers() {

      if (this.timeout) {

        window.clearTimeout(
          this.timeout
        );

        this.timeout = null;

      }

      if (this.interval) {

        window.clearInterval(
          this.interval
        );

        this.interval = null;

      }

    }


    start() {

      if (!this.autoplay) {
        return;
      }

      if (
        !this.visible ||
        this.hovering ||
        document.hidden ||
        this.reduceMotion
      ) {
        return;
      }

      if (
        this.timeout ||
        this.interval
      ) {
        return;
      }


      const wait =
        this.hasStarted
          ? this.delay
          : this.delay + this.startDelay;


      this.timeout =
        window.setTimeout(
          () => {

            this.timeout = null;

            this.next();

            this.hasStarted = true;


            this.interval =
              window.setInterval(
                () => {

                  if (
                    this.visible &&
                    !this.hovering &&
                    !document.hidden
                  ) {

                    this.next();

                  }

                },
                this.delay
              );

          },
          wait
        );

    }


    stop() {

      this.clearTimers();

    }


    /*
     * Após usuário clicar manualmente,
     * zeramos o timer.
     */

    manualInteraction() {

      this.clearTimers();

      /*
       * Enquanto mouse está em cima,
       * permanece pausado.
       *
       * Quando sair do card,
       * bindHover() reinicia.
       */

      if (!this.hovering) {

        this.start();

      }

    }


    /* =====================================================
       HOVER
       ===================================================== */

    bindHover() {

      this.element.addEventListener(
        'mouseenter',
        () => {

          this.hovering = true;

          this.stop();

        }
      );


      this.element.addEventListener(
        'mouseleave',
        () => {

          this.hovering = false;

          this.start();

        }
      );

    }


    /* =====================================================
       VIEWPORT
       ===================================================== */

    observe() {

      if (
        !('IntersectionObserver' in window)
      ) {

        this.visible = true;

        this.start();

        return;

      }


      this.observer =
        new IntersectionObserver(
          entries => {

            entries.forEach(
              entry => {

                this.visible =
                  entry.isIntersecting &&
                  entry.intersectionRatio >= 0.15;


                if (this.visible) {

                  this.preloadNext();

                  this.start();

                } else {

                  this.stop();

                }

              }
            );

          },
          {
            threshold: [
              0,
              0.15,
              0.5
            ]
          }
        );


      this.observer.observe(
        this.element
      );

    }

  }



  /* =======================================================
     INITIALIZE
     ======================================================= */

  function initPWSliders(scope = document) {

    const sliders =
      scope.querySelectorAll(
        '[data-pw-card-slider]:not([data-pw-slider-ready])'
      );


    sliders.forEach(slider => {

      slider.setAttribute(
        'data-pw-slider-ready',
        'true'
      );

      new PWProductCardSlider(
        slider
      );

    });

  }



  /* =======================================================
     CONTROLES
     
     IMPORTANTE:
     usamos CAPTURE = true.
     
     Assim nosso código recebe o clique ANTES do Prestige.
     ======================================================= */

  document.addEventListener(
    'click',
    event => {

      const control =
        event.target.closest(
          '[data-pw-prev], [data-pw-next], [data-pw-dot]'
        );


      if (!control) {
        return;
      }


      const sliderElement =
        control.closest(
          '[data-pw-card-slider]'
        );


      if (!sliderElement) {
        return;
      }


      const slider =
        sliderElement.pwSliderInstance;


      if (!slider) {
        return;
      }


      /*
       * Impede qualquer comportamento
       * do product-card do Prestige.
       */

      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();


      /* ANTERIOR */

      if (
        control.matches(
          '[data-pw-prev]'
        )
      ) {

        slider.previous();

        slider.manualInteraction();

        return;

      }


      /* PRÓXIMA */

      if (
        control.matches(
          '[data-pw-next]'
        )
      ) {

        slider.next();

        slider.manualInteraction();

        return;

      }


      /* DOT */

      if (
        control.matches(
          '[data-pw-dot]'
        )
      ) {

        const index =
          parseInt(
            control.dataset.index,
            10
          );


        if (
          !Number.isNaN(index)
        ) {

          slider.show(index);

          slider.manualInteraction();

        }

      }

    },

    /*
     * CAPTURE PHASE
     */
    true
  );



  /* =======================================================
     POINTER DOWN
     
     Também impedimos o Prestige de tratar o botão
     como clique no card.
     ======================================================= */

  document.addEventListener(
    'pointerdown',
    event => {

      const control =
        event.target.closest(
          '[data-pw-prev], [data-pw-next], [data-pw-dot]'
        );


      if (!control) {
        return;
      }


      event.stopPropagation();

    },

    true
  );



  /* =======================================================
     INIT PAGE
     ======================================================= */

  function init() {

    initPWSliders();


    /*
     * Collection filters / AJAX / Prestige
     */

    const observer =
      new MutationObserver(
        mutations => {

          let foundNewContent = false;


          mutations.forEach(
            mutation => {

              if (
                mutation.addedNodes.length
              ) {

                foundNewContent = true;

              }

            }
          );


          if (foundNewContent) {

            requestAnimationFrame(
              () => {

                initPWSliders();

              }
            );

          }

        }
      );


    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  }



  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }



  /* =======================================================
     SHOPIFY THEME EDITOR
     ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    event => {

      initPWSliders(
        event.target
      );

    }
  );



  /* =======================================================
     TAB VISIBILITY
     ======================================================= */

  document.addEventListener(
    'visibilitychange',
    () => {

      document
        .querySelectorAll(
          '[data-pw-card-slider]'
        )
        .forEach(element => {

          const slider =
            element.pwSliderInstance;


          if (!slider) {
            return;
          }


          if (document.hidden) {

            slider.stop();

          } else {

            slider.start();

          }

        });

    }
  );

})();


/* =========================================================
   PW SLIDER
   HARD FIX CONTROLES PRESTIGE
   ========================================================= */

document.addEventListener(
  'click',
  function(event) {

    const control = event.target.closest(
      '[data-pw-prev], [data-pw-next], [data-pw-dot]'
    );

    if (!control) {
      return;
    }


    const slider = control.closest(
      '[data-pw-card-slider]'
    );

    if (!slider) {
      return;
    }


    /*
     * Bloqueia qualquer clique do Prestige
     * no card/produto.
     */

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();


    const slides = Array.from(
      slider.querySelectorAll('[data-pw-slide]')
    );


    const dots = Array.from(
      slider.querySelectorAll('[data-pw-dot]')
    );


    if (slides.length <= 1) {
      return;
    }


    /*
     * Descobre slide atual diretamente pelo DOM.
     * Não depende do estado interno do JS anterior.
     */

    let currentIndex = slides.findIndex(
      slide =>
        slide.classList.contains('is-active')
    );


    if (currentIndex < 0) {
      currentIndex = 0;
    }


    let nextIndex = currentIndex;


    /* ANTERIOR */

    if (
      control.hasAttribute('data-pw-prev')
    ) {

      nextIndex =
        currentIndex - 1;

      if (nextIndex < 0) {

        nextIndex =
          slides.length - 1;

      }

    }


    /* PRÓXIMA */

    else if (
      control.hasAttribute('data-pw-next')
    ) {

      nextIndex =
        currentIndex + 1;

      if (
        nextIndex >= slides.length
      ) {

        nextIndex = 0;

      }

    }


    /* DOT */

    else if (
      control.hasAttribute('data-pw-dot')
    ) {

      const index =
        parseInt(
          control.dataset.index,
          10
        );


      if (
        !Number.isNaN(index)
      ) {

        nextIndex = index;

      }

    }


    /*
     * Carrega imagem lazy se necessário.
     */

    const targetSlide =
      slides[nextIndex];


    const image =
      targetSlide?.querySelector(
        '[data-pw-src]'
      );


    if (image) {

      const newSrc =
        image.dataset.pwSrc;


      if (newSrc) {

        image.src =
          newSrc;

        image.removeAttribute(
          'data-pw-src'
        );

      }

    }


    /*
     * Atualiza slides
     */

    slides.forEach(
      (slide, index) => {

        slide.classList.toggle(
          'is-active',
          index === nextIndex
        );

      }
    );


    /*
     * Atualiza dots
     */

    dots.forEach(
      (dot, index) => {

        const active =
          index === nextIndex;


        dot.classList.toggle(
          'is-active',
          active
        );


        dot.setAttribute(
          'aria-current',
          active
            ? 'true'
            : 'false'
        );

      }
    );


    /*
     * Sincroniza também com a instância
     * do autoplay, caso ela exista.
     */

    if (
      slider.pwSliderInstance
    ) {

      slider.pwSliderInstance.currentIndex =
        nextIndex;

    }

  },

  /*
   * CAPTURE PHASE:
   * nosso código pega o clique
   * ANTES do Prestige.
   */

  true
);